import { DiscountPool } from 'discounts/types'
import { BaseRouteParams } from 'hocs'
import React from 'react'
import { useParams } from 'react-router-dom'
import ActionButton from 'uiComponents/buttons'
import { Col, Row } from 'uiComponents/flex'
import { FormWrapper } from 'uiComponents/form/form'
import TextInputFieldFormik from 'uiComponents/input/textInput/textInputFieldFormik'
import { ModalDialogTitle } from 'uiComponents/popups/modal'
import { removeHash } from 'utils/hash'
import { useAddPoolMutation } from 'discounts/reduxQuery'
import { useTranslation } from 'translations'

interface AddPoolFormProps {
    onPoolAdd?: (pool: DiscountPool) => void
}

const AddPoolForm: React.FC<AddPoolFormProps> = ({ onPoolAdd }) => {
    const { t } = useTranslation()
    const { accountSlug } = useParams<BaseRouteParams>()
    const [addPool, { isLoading }] = useAddPoolMutation()

    return (
        <>
            <ModalDialogTitle>{t('discounts.addPool.title')}</ModalDialogTitle>
            <FormWrapper
                initialValues={{}}
                onSubmit={(values) => {
                    addPool({ accountSlug, name: values.name })
                        .unwrap()
                        .then((pool) => {
                            if (pool && onPoolAdd) {
                                onPoolAdd(pool)
                            }
                        })
                }}
            >
                <TextInputFieldFormik name="name" label={t('discounts.addPool.nameLabel')} required />
                <Row align="flex-end" style={{ paddingTop: '32px' }}>
                    <Col span="auto">
                        <ActionButton size="large" secondary onClick={removeHash}>
                            {t('common.cancel')}
                        </ActionButton>
                    </Col>
                    <Col span="auto">
                        <ActionButton disabled={isLoading} size="large" type="submit">
                            {t('discounts.addPool.submit')}
                        </ActionButton>
                    </Col>
                </Row>
            </FormWrapper>
        </>
    )
}

export default AddPoolForm
